import type { RefObject } from 'react';
import type { AutocompleteApi } from '@algolia/autocomplete-core';
import type { AutocompleteItem, ItemPricing } from './Searchbar.types';

export const formatPrice = (price: number) =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(price);

const DEFAULT_DISCOUNT = {
  discountType: '',
  featureInstallmentDiscount: false,
  paymentMethodsDiscount: '',
};

export function normalizeItemPricing(
  item: AutocompleteItem,
  region: string,
  storeSlug?: string,
): ItemPricing | undefined {
  if (item.regionalAttributes?.[region]) {
    return item.regionalAttributes[region];
  }

  if (storeSlug) {
    const storeData = item[`store_${storeSlug}`] as
      | {
          originalPrice: number;
          promotionalPrice: number;
          offer: { enabled: boolean };
        }
      | undefined;

    if (storeData) {
      return {
        originalPrice: storeData.originalPrice,
        promotionalPrice: storeData.promotionalPrice,
        offer: { enabled: storeData.offer?.enabled ?? false },
        discount: DEFAULT_DISCOUNT,
      };
    }
  }

  return undefined;
}

export const getAutocompleteProps = (
  autocomplete: AutocompleteApi<
    AutocompleteItem,
    React.BaseSyntheticEvent,
    React.MouseEvent,
    React.KeyboardEvent
  >,
  inputRef: RefObject<HTMLInputElement>,
  autocompleteId: string,
) => {
  return {
    root: autocomplete.getRootProps(),
    form: autocomplete.getFormProps({
      inputElement: inputRef.current,
    }),
    input: autocomplete.getInputProps({
      inputElement: inputRef.current,
      id: autocompleteId,
      // eslint-disable-next-line no-useless-computed-key
      ['aria-labelledby']: null,
    }),
    panel: autocomplete.getPanelProps(),
  };
};
